<template>
  <div class="p-4 bg-white rounded shadow ">
    <h2 class="text-lg font-semibold mb-4">
      💬 แชทกับ {{ user.name || "ไม่ทราบชื่อ" }}
    </h2>

    
    <div class="h-[500px] overflow-y-auto border rounded p-3 space-y-4 bg-blue-100">
            <div
              v-for="msg in messages"
              :key="msg.created_at"
              :class="[msg.sender === 'user' ? 'flex justify-end' : msg.sender === 'user_action' ? 'flex justify-center' : 'flex justify-start']"
            >
    
                      
            <!-- ✅ Card แสดงตำแหน่ง location จากลูกค้า (ใช้ Google Static Map) -->
            <div
              v-if="msg.message_type === 'location'"
              class="w-full max-w-[250px] rounded-2xl overflow-hidden shadow border border-gray-300 bg-white flex flex-col"
            >
              <!-- Hero (Static Map กดได้) -->
              <a
                :href="`https://www.google.com/maps?q=${msg.raw_json?.message?.latitude},${msg.raw_json?.message?.longitude}`"
                target="_blank"
                class="block"
              >
                <img
                  :src="getStaticMapUrl(msg)"
                  alt="Google Map Preview"
                  class="w-full object-cover aspect-[3/2]"
                >
              </a>

              <!-- Body (แสดงที่อยู่) -->
              <div class="bg-green-400 px-3 py-2 text-xs text-white flex flex-col">
                <div class="text-gray-500 text-xs whitespace-pre-wrap leading-snug">
                  {{ msg.raw_json?.message?.address || 'ไม่พบที่อยู่' }}
                </div>
                <div class="text-gray-500 bg-green-400 rounded-md px-2 py-1 mb-2 font-semibold truncate">
                  📍 ตำแหน่งที่ตั้ง
                </div>
              </div>
            </div>


            <!-- ✅ user_action  -->
            <div
              v-if="msg.sender === 'user_action'"
              class="bg-black bg-opacity-30 text-black text-[10px] px-3 py-1 rounded-full max-w-[80%] text-center"
            >
              {{ msg.message }}
            </div>
            
            <!-- ✅ Horizontal Flex Cards สำหรับ admin -->
            <div
                v-else-if="msg.sender === 'admin' && msg.message_type === 'json' && msg.action === 'loc_admin_choose_branch'"
                class="w-full overflow-x-auto"
              >
                <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0 items-stretch">
                  <div
                    v-for="(card, index) in msg.raw_json?.contents?.contents"
                    :key="index"
                    class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white text-gray-800 flex flex-col hover:shadow-lg transition-shadow duration-200"
                  >
                    <!-- Header -->
                    <div class="flex items-center justify-between bg-black px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl">
                      <div class="flex items-center gap-1">
                        <img
                          :src="card.header?.contents?.[0]?.url || 'https://cdn-icons-png.flaticon.com/512/921/921347.png'"
                          class="w-5 h-5 object-cover"
                        />
                        <span>Staff Agent</span>
                      </div>
                      <div class="flex items-center text-[10px]">
                        <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
                      </div>
                    </div>

                    <!-- Hero -->
                    <div class="relative w-full aspect-[3/1] overflow-hidden">
                      <img
                        :src="card.hero?.url || card.hero?.contents?.[0]?.url || 'https://placehold.co/600x200?text=No+Image'"
                        class="w-full h-full object-cover"
                      />
                    </div>

                    <!-- Body -->
                    <div class="p-3 text-xs flex flex-col justify-between ">
                      <div class="min-h-[80px] flex flex-col justify-start">
                        <div class="text-lg font-bold line-clamp-2 break-words">
                          {{ card.body?.contents?.[0]?.text || 'ไม่พบชื่อสาขา' }}
                        </div>
                        <div class="text-xs text-gray-600 mt-1 line-clamp-2 break-words">
                          {{ card.body?.contents?.[1]?.text || 'ไม่พบที่อยู่' }}
                        </div>
                      </div>

                  <!-- เวลาทำการ + ปุ่ม -->
                  <div class="flex gap-3 items-start pt-2">
                      <!-- Opening Hours -->
                      <div class="flex flex-col flex-1 text-[11px] text-gray-600 pr-2">
                        <div class="flex justify-between font-bold text-gray-400 text-[10px] mb-1">
                      <div class="flex-1 text-left">วัน</div>
                      <div class="flex-1 text-right">เวลา</div>
                    </div>
                    <div v-for="(row, i) in getTimeRows(card)" :key="i" class="flex justify-between">
                      <div
                        class="flex-1 text-left"
                        :class="{ 'text-red-500 font-semibold': row.time.includes('ปิด') || row.time.includes('หยุด') }"
                      >
                        {{ row.day }}
                      </div>
                      <div
                        class="flex-1 text-right"
                        :class="{ 'text-red-500 font-semibold': row.time.includes('ปิด') || row.time.includes('หยุด') }"
                      >
                        {{ row.time }}
                      </div>
                    </div>

                      </div>

                      <!-- Buttons -->
                      <div class="flex flex-col flex-1 gap-2 justify-end self-end">
                        <a
                          :href="getBotMapUrl(card)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="bg-gray-100 text-black text-xs font-normal px-2 py-3 rounded-md border border-gray-300 flex items-center justify-center gap-1 w-full"
                        >
                          <span>🗺️</span>
                          <span>แผนที่</span>
                        </a>

                        <a
                          :href="getBotCallUrl(card)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="bg-green-100 text-black text-xs px-2 py-3 rounded-md border border-green-400 flex items-center justify-center gap-1 w-full"
                        >
                          <span>📞</span>
                          <span class="font-bold">โทร</span>
                        </a>

                      </div>

                  </div>
                    </div>
                  </div>
                </div>
            </div>
            <!-- แสดง qr-->
            <div
                v-else-if="msg.action === 'qr_pay' && msg.message_type === 'json'"
                class="w-full overflow-x-auto"
              >
                <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0 items-stretch">
                  <div
                    class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white text-gray-800 flex flex-col hover:shadow-lg transition-shadow duration-200"
                  >
                    <div
                    class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl"
                  >
                    <div class="flex items-center gap-1">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/4712/4712027.png"
                        class="w-5 h-5"
                      />
                      <span>Bot Agent</span>
                    </div>
                    <div class="flex items-center text-[10px]">
                      <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
                    </div>
                  </div>

                    <div class="p-3 flex flex-col justify-center items-center">
                      <p>📱 กรุณาสแกน QR เพื่อชำระเงิน </p>
                      <img
                        v-if="msg.raw_json?.url"
                        :src="msg.raw_json?.url"
                        class="w-full rounded-md object-contain"
                        style="max-height: 300px;"
                      />
                      <div v-else class="text-sm text-gray-500 italic">ไม่พบรูปภาพ QR Code</div>
                    </div>
                  </div>
                </div>
              </div>
            <!-- slip_confirm -->
            <div
                v-else-if="msg.action === 'slip_confirm' && msg.message_type === 'json' && msg.raw_json"
                class="w-full overflow-x-auto"
              >
                <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0 items-stretch">
                  <div
                    class="min-w-[280px] max-w-[95vw] sm:max-w-[360px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white text-gray-800 flex flex-col"
                  >
                    <div
                    class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl"
                  >
                    <div class="flex items-center gap-1">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/4712/4712027.png"
                        class="w-5 h-5"
                      />
                      <span>Bot Agent</span>
                    </div>
                    <div class="flex items-center text-[10px]">
                      <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
                    </div>
                  </div>

                    <div class="p-4 text-sm flex flex-col">
                      <div class="text-md font-bold text-green-600 mb-2">
                        ยืนยันการชำระเงิน
                      </div>
                      <div class="text-gray-600 mb-2">
                        Order ID: <b class="text-gray-800">{{ msg.raw_json.order_id }}</b>
                      </div>
                      <div class="text-gray-700 font-semibold mb-2">
                        📦 รายการ ({{ msg.raw_json.items?.length || 0 }} รายการ)
                      </div>
                      <div class="mb-3 space-y-1">
                        <div
                          v-for="(item, index) in msg.raw_json.items"
                          :key="index"
                          class="flex items-center justify-between"
                        >
                          <div class="text-gray-800 line-clamp-1 break-words">{{ item.title }}</div>
                          <div class="text-gray-600">x{{ item.quantity }}</div>
                        </div>
                      </div>
                      <div class="border-t border-gray-300 pt-2 mb-2">
                        <div class="flex justify-between items-center">
                          <span class="text-gray-700 font-semibold">💰 ยอดรวม:</span>
                          <span class="text-gray-800 font-bold">฿{{ formatNumber(msg.raw_json.total) }}</span>
                        </div>
                      </div>
                      <div class="border-t border-gray-300 pt-2 mb-2">
                        <div class="text-gray-700 font-semibold mb-1">📍 ที่อยู่จัดส่ง</div>
                        <div class="text-gray-600 text-xs">
                          {{ msg.raw_json.order?.name }}<br />
                          {{ msg.raw_json.order?.address }}<br />
                          📞 {{ msg.raw_json.order?.phone }}
                        </div>
                      </div>
                      <div class="mt-4">
                        <button
                          class="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 rounded-md"
                          @click="handleSlipConfirmation(msg.raw_json.order_id)"
                        >
                          ✅ ยืนยันสลิปโอนเงิน
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          <!-- ✅ Card แสดงตำแหน่งที่ปักหมุด (bot) และ message เป็น 📍 ตำแหน่งที่คุณค้นหา -->
          <div
            v-else-if="msg.sender === 'bot' 
              && msg.message_type === 'json' 
              && ['loc_ans_show_address'].includes(msg.action)
              && msg.raw_json?.contents?.body?.contents?.[0]?.text?.startsWith('📍 ตำแหน่งที่คุณค้นหา')"
            class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl overflow-hidden shadow border border-gray-300 bg-white"
          >
            <!-- Header -->
            <div class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold">
              <div class="flex items-center gap-1">
                <img
                  :src="msg.raw_json?.contents?.header?.contents?.[0]?.url || 'https://cdn-icons-png.flaticon.com/512/4712/4712027.png'"
                  class="w-5 h-5 object-cover"
                />
                <span>Bot Agent</span>
              </div>
              <div class="flex items-center text-[10px]">
                <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
              </div>
            </div>

            <!-- Hero (Static Map) กดได้ -->
            <a
              :href="msg.raw_json?.contents?.hero?.action?.uri"
              target="_blank"
              class="block w-full"
            >
              <img
                :src="msg.raw_json?.contents?.hero?.url"
                class="w-full aspect-[3/2] object-cover"
              />
            </a>

            <!-- Body (ที่อยู่) -->
            <div class="p-3 text-xs text-gray-800">
              {{ msg.raw_json?.contents?.body?.contents?.[0]?.text || 'ตำแหน่งที่ปักหมุด' }}
            </div>
          </div>

          <!-- ✅ Card แสดงตำแหน่งที่ค้นหา (bot) -->
          <div
            v-else-if="msg.sender === 'bot' 
              && msg.message_type === 'json' 
              && ['loc_ans_show_address_display'].includes(msg.action)"
            class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl overflow-hidden shadow border border-gray-300 bg-white"
          >
            <!-- Header -->
            <div class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold">
              <div class="flex items-center gap-1">
                <img
                  :src="msg.raw_json?.contents?.header?.contents?.[0]?.url || 'https://cdn-icons-png.flaticon.com/512/4712/4712027.png'"
                  class="w-5 h-5 object-cover"
                />
                <span>Bot Agent</span>
              </div>
              <div class="flex items-center text-[10px]">
                <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
              </div>
            </div>

            <!-- Hero (Static Map) กดได้ -->
            <a
              :href="msg.raw_json?.contents?.hero?.action?.uri"
              target="_blank"
              class="block w-full"
            >
              <img
                :src="msg.raw_json?.contents?.hero?.url"
                class="w-full aspect-[3/2] object-cover hover:opacity-90 cursor-pointer"
              />
            </a>

            <!-- Body (ที่อยู่) -->
            <div class="p-3 text-xs text-gray-800">
              {{ msg.raw_json?.contents?.body?.contents?.[0]?.text || 'ตำแหน่งที่ปักหมุด' }}
            </div>
          </div>


          <!-- ✅ Card แสดงตำแหน่งที่ค้นหา (admin) -->
          <div
            v-else-if="msg.sender === 'admin' 
              && msg.message_type === 'json' 
              && ['loc_admin_address_display', 'loc_admin_pin_display'].includes(msg.action)"
            class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl overflow-hidden shadow border border-gray-300 bg-white"
          >
            <!-- Header -->
            <div class="flex items-center justify-between bg-black px-3 py-1.5 text-white text-xs font-bold">
              <div class="flex items-center gap-1">
                <img
                  :src="(msg.raw_json?.contents?.contents?.header?.contents?.[0]?.url || msg.raw_json?.contents?.header?.contents?.[0]?.url) || 'https://cdn-icons-png.flaticon.com/512/921/921347.png'"
                  class="w-5 h-5 object-cover"
                />
                <span>Staff Agent</span>
              </div>
              <div class="flex items-center text-[10px]">
                <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
              </div>
            </div>

            <!-- Hero (Map คลิกได้) -->
            <a
              :href="(msg.raw_json?.contents?.contents?.hero?.action?.uri || msg.raw_json?.contents?.hero?.action?.uri) || '#'"
              target="_blank"
              class="block"
            >
              <img
                :src="(msg.raw_json?.contents?.contents?.hero?.url || msg.raw_json?.contents?.hero?.url)"
                class="w-full aspect-[3/2] object-cover"
              />
            </a>

            <!-- Body -->
            <div class="p-3 text-xs text-gray-800">
              {{ (msg.raw_json?.contents?.contents?.body?.contents?.[0]?.text || msg.raw_json?.contents?.body?.contents?.[0]?.text) || 'ตำแหน่งที่ค้นหา' }}
            </div>
          </div>

          <!-- ✅ Card แสดงlocation ฝั่ง admin    loc_admin_address_search loc_admin_pin_nearest loc_admin_all_branch-->
          <div
            v-if="msg.sender === 'admin' && msg.message_type === 'json' && ['loc_admin_address_search', 'loc_admin_pin_nearest', 'loc_admin_all_branch'].includes(msg.action)"
            class="w-full overflow-x-auto"
          >
            <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0 items-stretch">
              <div
                v-for="(card, index) in msg.raw_json"
                :key="index"
                class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white flex flex-col hover:shadow-lg transition-shadow duration-200"
              >
                <!-- Header -->
                <div class="flex items-center justify-between bg-black px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl">
                  <div class="flex items-center gap-1">
                    <img
                      :src="card.bot_header?.icon_url || 'https://cdn-icons-png.flaticon.com/512/921/921347.png'"
                      class="w-5 h-5 object-cover"
                    />
                    <span>{{ card.bot_header?.title || 'Staff Agent' }}</span>
                  </div>
                  <div class="flex items-center text-[10px]">
                    <span class="italic">powered by</span>
                    <a
                      :href="card.bot_header?.url || 'http://indigointer.com?line2sell'"
                      target="_blank"
                      class="not-italic ml-0.5"
                    >
                      {{ card.bot_header?.powered_by || 'LINE2Sell' }}
                    </a>
                  </div>
                </div>

                <!-- Hero -->
                <div class="relative w-full aspect-[3/1] overflow-hidden">
                  <img
                    :src="card.image_url || 'https://placehold.co/600x200?text=No+Image'"
                    class="w-full h-full object-cover"
                  />
                  <div
                    v-if="card.distance_km"
                    class="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-[10px] px-2 py-1 rounded-md"
                  >
                    📍 {{ card.distance_km }} กม.
                  </div>
                </div>

                <!-- Body -->
                <div class="p-3 text-xs text-gray-800 flex flex-col justify-between min-h-[250px]">
                  <div class="text-lg font-bold line-clamp-2 break-words">
                    {{ card.location_name || 'ไม่พบชื่อสาขา' }}
                  </div>
                  <div class="text-xs text-gray-600 mt-1 line-clamp-2 break-words">
                    {{ card.address || 'ไม่พบที่อยู่' }}
                  </div>

                  <!-- Opening Hours -->
                  <div class="flex gap-3 items-start pt-2">
                    <div class="flex flex-col flex-1 text-[11px] text-gray-600 pr-2">
                      <div class="flex justify-between font-bold text-gray-400 text-[10px] mb-1">
                        <div class="flex-1 text-left">วัน</div>
                        <div class="flex-1 text-right">เวลา</div>
                      </div>
                      <div
                        v-for="(time, day) in card.open_days"
                        :key="day"
                        class="flex justify-between"
                      >
                        <div
                          class="flex-1 text-left"
                          :class="{ 'text-red-500 font-semibold': time.includes('ปิด') || time.includes('หยุด') }"
                        >
                          {{ day }}
                        </div>
                        <div
                          class="flex-1 text-right"
                          :class="{ 'text-red-500 font-semibold': time.includes('ปิด') || time.includes('หยุด') }"
                        >
                          {{ time }}
                        </div>
                      </div>
                    </div>

                    <!-- Buttons -->
                    <div class="flex flex-col flex-1 gap-2 justify-end self-end">
                      <a
                        :href="card.map_link || '#'"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bg-gray-100 text-black text-xs font-normal px-2 py-3 rounded-md border border-gray-300 flex items-center justify-center gap-1 w-full"
                      >
                        <span>🗺️</span>
                        <span>แผนที่</span>
                      </a>

                      <a
                        :href="card.tel_link || '#'"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bg-green-100 text-black text-xs px-2 py-3 rounded-md border border-green-400 flex items-center justify-center gap-1 w-full"
                      >
                        <span>📞</span>
                        <span class="font-bold">โทร</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ✅ Horizontal Flex Cards location สำรหับ bot  loc_ans_gps_show loc_ans_show_nearest loc_ans_show_all -->
          <div
            v-else-if="['bot'].includes(msg.sender) 
              && msg.message_type === 'json' 
              && ['loc_ans_gps_show','loc_ans_show_nearest','loc_ans_show_all'].includes(msg.action)"
              class="w-full overflow-x-auto"
          >
            <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0 items-stretch">
              <div
                v-for="(branch, index) in msg.raw_json"
                :key="index"
                class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white flex flex-col hover:shadow-lg transition-shadow duration-200"
              >
                <!-- Header -->
                <div class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl">
                  <div class="flex items-center gap-1">
                    <img
                      :src="branch.bot_header?.icon_url || 'https://cdn-icons-png.flaticon.com/512/4712/4712027.png'"
                      class="w-5 h-5 object-cover"
                    />
                    <span>{{ branch.bot_header?.title || 'Bot Agent' }}</span>
                  </div>
                  <div class="flex items-center text-[10px]">
                    <span class="italic">powered by</span>
                    <a
                      :href="branch.bot_header?.url || 'http://indigointer.com?line2sell'"
                      target="_blank"
                      class="not-italic ml-0.5"
                    >
                      LINE2Sell
                    </a>
                  </div>
                </div>


                <!-- Hero -->
                <div class="relative w-full aspect-[3/1] overflow-hidden">
                  <img
                    :src="branch.image_url || 'https://placehold.co/600x200?text=No+Image'"
                    class="w-full h-full object-cover"
                  />
                  <div
                    v-if="branch.distance_km"
                    class="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-[10px] px-2 py-1 rounded-md"
                  >
                  📍 {{ branch.distance_km }} กม.
                  </div>
                </div>

                <!-- Body -->
                <div class="p-3 text-xs text-gray-800 flex flex-col justify-between min-h-[250px]">
                  <!-- Name + Address -->
                  <div class="flex flex-col justify-start">
                    <div class="text-lg font-bold line-clamp-2 break-words">
                      {{ branch.location_name || 'ไม่พบชื่อสาขา' }}
                    </div>
                    <div class="text-xs text-gray-600 mt-1 line-clamp-2 break-words">
                      {{ branch.address || 'ไม่พบที่อยู่' }}
                    </div>
                  </div>

                  <!-- Time + Buttons -->
                  <div class="flex gap-3 items-start">
                    <!-- Opening Hours -->
                    <div class="flex flex-col flex-1 text-[11px] text-gray-600 pr-2">
                      <div class="flex justify-between font-bold text-gray-400 text-[10px] mb-1">
                        <div class="flex-1 text-left">วัน</div>
                        <div class="flex-1 text-right">เวลา</div>
                      </div>
                      <div
                        v-for="(row, i) in groupDays(branch.open_days)"
                        :key="i"
                        class="flex justify-between"
                      >
                        <div
                          class="flex-1 text-left"
                          :class="{ 'text-red-500 font-semibold': row.time.includes('ปิด') || row.time.includes('หยุด') }"
                        >
                          {{ row.days }}
                        </div>
                        <div
                          class="flex-1 text-right"
                          :class="{ 'text-red-500 font-semibold': row.time.includes('ปิด') || row.time.includes('หยุด') }"
                        >
                          {{ row.time }}
                        </div>
                      </div>
                    </div>



                    <!-- Buttons -->
                    <div class="flex flex-col flex-1 gap-2 justify-end self-end">
                      <a
                        :href="branch.map_link || '#'"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bg-gray-100 text-black text-xs font-normal px-2 py-3 rounded-md border border-gray-300 flex items-center justify-center gap-1 w-full"
                      >
                        <span>🗺️</span>
                        <span>แผนที่</span>
                      </a>

                      <a
                        :href="branch.tel_link || '#'"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bg-green-100 text-black text-xs px-2 py-3 rounded-md border border-green-400 flex items-center justify-center gap-1 w-full"
                      >
                        <span>📞</span>
                        <span class="font-bold">โทร</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- ✅ Horizontal Flex Cards for promo_ans_show_parent -->
            <div
              v-else-if="msg.sender === 'bot' && msg.message_type === 'json' && msg.action === 'promo_ans_show_parent'"
              class="overflow-x-auto w-full"
            >
              <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0">
                <div
                  v-for="(promo, index) in msg.raw_json?.promotions"
                  :key="index"
                  class="min-w-[260px] max-w-xs overflow-hidden rounded-2xl shadow border border-gray-300 bg-white flex-shrink-0"
                >
                  <div
                    class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl"
                  >
                    <div class="flex items-center gap-1">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/4712/4712027.png"
                        class="w-5 h-5"
                      />
                      <span>Bot Agent</span>
                    </div>
                    <div class="flex items-center text-[10px]">
                      <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
                    </div>
                  </div>

                  <img
                    :src="promo?.image || 'https://placehold.co/600x300?text=Image'"
                    class="w-full object-cover aspect-[1/1]"
                  />

                  <div class="p-3 text-xs text-gray-800 space-y-1">
                    <div class="text-lg font-bold">
                      {{ promo?.title || "ไม่พบหัวข้อ" }}
                    </div>
                    <div class="text-sm text-gray-600">
                      {{ promo?.subtitle || "-" }}
                    </div>
                    <div class="text-sm text-gray-500">
                      {{ promo?.detail || "-" }}
                    </div>
                  </div>

                  <div class="p-3">
                    <button
                      class="w-full py-2 rounded-lg text-sm font-bold bg-emerald-500 text-white"
                    >
                      🧾 ดูรายละเอียด
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <!-- ✅ Flex Card สำหรับ promo_ans_show_child -->
            <div
              v-else-if="msg.sender === 'bot' && msg.message_type === 'json' && msg.action === 'promo_ans_show_child'"
              class="w-full overflow-x-auto"
            >
              <div class="flex gap-3 sm:gap-4 w-fit px-2 sm:px-0">
                <div
                  v-for="(card, index) in msg.raw_json?.contents?.contents"
                  :key="index"
                  class="min-w-[240px] sm:min-w-[280px] max-w-[95vw] sm:max-w-[300px] flex-shrink-0 rounded-2xl shadow border border-gray-300 bg-white"
                >
                  <!-- Header -->
                  <div class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-2xl">
                    <div class="flex items-center gap-1">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/4712/4712027.png"
                        class="w-5 h-5"
                      />
                      <span>Bot Agent</span>
                    </div>
                    <div class="flex items-center text-[10px]">
                      <span class="italic">powered by</span><b class="not-italic ml-0.5">LINE2Sell</b>
                    </div>
                  </div>

                  <!-- Image -->
                  <img
                    :src="card.hero?.url || 'https://placehold.co/600x300?text=Image'"
                    alt="promotion"
                    class="w-full object-cover aspect-[16/9]"
                  />

                  <!-- Body -->
                  <div class="p-3 text-xs text-gray-800 space-y-1">
                    <!-- ✅ หมวดโปรโมชัน -->
                    <div :class="index === 0 
                      ? 'text-lg font-bold text-black' 
                      : 'text-xs font-bold text-emerald-600'"
                    >
                      {{ card.body?.contents?.[0]?.text || '' }}
                    </div>


                    <!-- ✅ ชื่อโปรโมชัน -->
                    <div :class="index === 0 
                      ? 'text-sm text-gray-1000' 
                      : 'text-lg font-bold'"
                    >
                      {{ card.body?.contents?.[1]?.text || card.body?.contents?.[1]?.contents?.[0]?.text || '' }}
                    </div>

                    <!-- ✅ รายละเอียด -->
                    <div class="text-sm text-gray-600">
                      {{ card.body?.contents?.[2]?.text || '' }}
                    </div>

                    <!-- ✅ ราคา -->
                    <div class="flex items-end gap-2 mt-2">
                      <div>
                        <div class="text-sm text-red-500 line-through">
                          {{ card.body?.contents?.[3]?.contents?.[0]?.contents?.[0]?.text || '' }}
                        </div>
                        <div class="text-2xl font-bold text-gray-400">
                          {{ card.body?.contents?.[3]?.contents?.[0]?.contents?.[1]?.text || '' }}
                        </div>
                      </div>
                      <div class="text-xl font-bold text-gray-700">บาท</div>
                    </div>
                  </div>

                  <!-- Footer -->
                  <div class="flex flex-col gap-2 p-3">
                    <button
                      v-for="btn in card.footer?.contents"
                      :key="btn.action?.label"
                      class="border py-2 rounded-full text-sm font-bold"
                      :class="btn.action?.label?.includes('สั่งซื้อ') ? 'bg-green-500 text-white' : 'text-black bg-white'"
                    >
                      {{ btn.contents?.[0]?.text || btn.action?.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ flex message / sender === 'bot' และ message_type === 'text' -->
            <div
              v-else-if="msg.sender === 'bot' && msg.message_type === 'text'"
              class="flex flex-col items-start w-full max-w-[30%]"
            >
              <!-- ✅ Bubble ข้อความ -->
              <div class="text-base overflow-hidden rounded-xl w-full">
                <!-- Header -->
                <div class="flex items-center justify-between bg-green-600 px-3 py-1.5 text-white text-xs font-bold rounded-t-xl">
                  <div class="flex items-center gap-1">
                    <img
                      :src="msg.raw_json?.contents?.header?.contents?.[0]?.url || 'https://cdn-icons-png.flaticon.com/512/4712/4712027.png'"
                      class="w-5 h-5"
                      alt="icon"
                    />

                    <span>{{ msg.raw_json?.contents?.header?.contents?.[1]?.text || "Bot Agent" }}</span>
                  </div>
                  <div class="flex items-center text-[10px]">
                    <span class="italic">
                      {{
                        msg.raw_json?.contents?.header?.contents?.[2]?.contents?.[0]?.text || "powered by"
                      }}
                    </span>
                    <b class="not-italic ml-0.5">
                      {{ msg.raw_json?.contents?.header?.contents?.[2]?.contents?.[1]?.text || "LINE2Sell" }}
                    </b>
                  </div>
                </div>

                <!-- Body -->
                <div
                  class="bg-white px-3 py-2 text-gray-800 text-xs rounded-b-xl w-full break-words whitespace-pre-wrap min-h-[40px]"
                >
                  {{ extractTextFromRawJson(msg.raw_json) }}
                </div>
              </div>

              <!-- ✅ Quick Reply -->
              <div
                v-if="getQuickReplies(msg.raw_json)?.length"
                class="mt-2 overflow-x-auto w-full"
              >
                <div class="flex flex-nowrap gap-2 w-max">
                  <div
                    v-for="(item, i) in getQuickReplies(msg.raw_json)"
                    :key="i"
                    class="flex-shrink-0 bg-gray-800 text-white text-xs px-3 py-1.5 rounded-full shadow flex items-center gap-1"
                  >
                    {{ item.action.label }}
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ flex message / sender === 'admin' และ message_type === 'text' -->
            <div
              v-else-if="msg.sender === 'admin' && msg.message_type === 'text'"
              class="flex flex-col items-end w-full max-w-[30%]"
            >
              <div class="text-base overflow-hidden rounded-xl w-full">
                <!-- Header -->
                <div class="flex items-center justify-between bg-black px-3 py-1.5 text-white text-xs font-bold rounded-t-xl">
                  <div class="flex items-center gap-1">
                    <!-- ✅ ดึงรูปจาก JSON -->
                    <img
                      :src="msg.raw_json?.contents?.header?.contents?.[0]?.url"
                      class="w-4 h-4 object-cover"
                      v-if="msg.raw_json?.contents?.header?.contents?.[0]?.type === 'image'"
                    />
                    <span>Staff Agent</span>
                  </div>

                  <!-- ✅ ต่อกันแบบพอดี -->
                  <div class="flex items-center text-[10px]">
                    <span class="italic">powered by </span><b class="not-italic ml-0.5">LINE2Sell</b>
                  </div>
                </div>

                <!-- Body -->
                <div class="bg-white px-3 py-2 text-gray-800 text-xs rounded-b-xl w-full break-words whitespace-pre-wrap min-h-[40px]">
                  {{ extractTextFromRawJson(msg.raw_json) }}
                </div>
              </div>
            </div>

            <div
              v-else-if="msg.sender === 'user' && msg.message_type === 'image'"
              class="flex flex-col items-end w-full max-w-[90%]"
            >
              <div class="rounded-xl overflow-hidden">
                <img
                  v-if="msg.raw_json?.slip_url"
                  :src="msg.raw_json?.slip_url"
                  alt="ภาพจากผู้ใช้"
                  class="w-[200px] h-auto object-cover rounded-xl border border-gray-200"
                />
                <div v-else class="text-xs text-gray-500 italic">ไม่พบ URL รูปภาพ</div>
                
              </div>
            </div>

            <!-- ✅ แสดงภาพถ้าเป็นข้อความจาก admin และเป็น image -->
            <div
              v-else-if="msg.sender === 'admin' && msg.message_type === 'image'"
              class="flex flex-col items-start w-full max-w-[60%]" 
              >
              <div class="rounded-xl overflow-hidden">
                <img
                  :src="msg.raw_json?.previewImageUrl || msg.raw_json?.originalContentUrl"
                  alt="ภาพจากแอดมิน"
                  class="w-[200px] h-auto object-cover rounded-xl border border-gray-200"
                />
              </div>
            </div>

            <div
              v-else-if="msg.sender === 'bot' && msg.message_type === 'image' && msg.action === 'slip_ad_confirm'"
              class="flex flex-col items-start  max-w-[90%] bg-white rounded-xl shadow border border-gray-200 p-3"
            >
              <div class="rounded-xl overflow-hidden mb-2 w-fit">
                <img
                  v-if="msg.raw_json?.slip_url"
                  :src="msg.raw_json?.slip_url"
                  alt="สลิปที่ส่งมา"
                  class="w-[200px] h-auto object-cover rounded-md border border-gray-200"
                />
                <div v-else class="text-xs text-gray-500 italic">ไม่พบ URL สลิป</div>
              </div>
              <div class="flex gap-2 ">
                <button
                  class="flex-1 bg-red-100 hover:bg-red-200 text-red-700 font-semibold py-2 px-4 rounded-md text-sm border border-red-300"
                  @click="requestNewSlip(msg.raw_json?.order_id, user.user_id)"
                >
                  กรุณาส่งสลิปใหม่
                </button>
                <button
                  class="flex-1 bg-green-100 hover:bg-green-200 text-green-700 font-semibold py-2 px-4 rounded-md text-sm border border-green-300"
                  @click="approveSlip(msg.raw_json?.order_id, user.user_id)"
                >
                  สลิปถูกต้อง
                </button>
              </div>
            </div>
            
            <!-- ✅ แสดง sticker message ทั้งจาก user และ bot -->
            <div
              v-else-if="msg.message_type === 'sticker'"
              :class="msg.sender === 'user' ? 'flex justify-end' : 'flex justify-start'"
              class="w-full"
            >
              <div class="bg-transparent p-1 rounded-xl">
                <img
                  :src="getStickerUrl(msg.raw_json)"
                  class="w-28 h-28 object-contain"
                  alt="Sticker"
                />
                
              </div>
            </div>

            <!-- ✅ user / bot ปกติ -->
            <div
              v-else-if="!['json'].includes(msg.message_type) && msg.sender !== 'user_action' && msg.message_type !== 'location'"
            >
              <div
                :class="[ 
                  'px-4 py-2 whitespace-pre-wrap rounded-xl text-sm',
                  msg.sender === 'user' ? 'bg-green-300 text-gray-900' : 'bg-white text-gray-800 border rounded-bl-none'
                ]"
              >
                <div v-if="msg.message_type === 'text'">{{ msg.message }}</div>
                <div v-else-if="msg.message_type === 'json'" class="italic text-sm text-gray-400">
                  [Flex Message]
                </div>
                <div v-else class="italic text-xs text-gray-400">
                  ({{ msg.message_type }})
                </div>
              </div>

              <div class="text-[10px] text-gray-400 mt-1 text-right">
                {{ formatDate(msg.created_at) }}
              </div>
            </div>

            </div>

            <div ref="chatEnd"></div>
    </div>

            <!-- ปุ่ม + และเมนู Action -->
            <div class="flex items-center bg-white rounded-full shadow px-2 py-1 mt-3 relative">
            <!-- ปุ่ม + -->
            <div class="relative">
              <button
                @click="toggleMenu"
                class="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-2xl shadow"
              >
                +
              </button>

              <!-- ⬇️ ซ่อน input ไว้ -->
              <input
                type="file"
                ref="imageInput"
                accept="image/*"
                @change="handleImageUpload"
                class="hidden"
              />

              <!-- เมนูย่อย -->
              <div
                v-if="showMenu"
                class="absolute bottom-12 left-0 bg-white rounded-lg shadow p-2 flex flex-col gap-2 z-50"
              >
                <button @click="selectAction('location')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">location</button>
                <button @click="selectAction('promo')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">promo</button>
                <button @click="selectAction('video')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">video</button>
                <button @click="selectAction('images')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">images</button>
                <button @click="selectAction('audio')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">audio</button>
                <button @click="selectAction('sticker')" class="bg-gray-200 px-4 py-1 rounded-full text-sm">sticker</button>

              </div>
            </div>

            <!-- ช่องพิมพ์ -->
            <input
              id="chat-input"
              v-model="newMessage"
              @keyup.enter="sendMessage"
              type="text"
              placeholder="พิมพ์ข้อความ..."
              class="flex-1 mx-2 border-none focus:ring-0 focus:outline-none text-sm"
              aria-label="ช่องกรอกข้อความ"
            />

            <!-- ปุ่มส่ง -->
            <button
              @click="sendMessage"
              class="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-600 text-white rounded-full"
            >
              ➤
            </button>

          </div>

            <!-- ✅ Sticker Picker Modal -->
            <div
              v-if="showStickerPicker"
              class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
            >
              <div class="bg-white p-4 rounded shadow w-[90%] max-w-md max-h-[80vh] overflow-y-auto">
                <h3 class="text-lg font-bold mb-3">เลือกสติกเกอร์</h3>
                <div class="grid grid-cols-3 gap-3">
                  <div
                    v-for="sticker in stickers"
                    :key="sticker.stickerId"
                    @click="sendStickerById(sticker.packageId, sticker.stickerId)"
                    class="cursor-pointer hover:scale-105 transition"
                  >
                    <img
                      :src="`https://stickershop.line-scdn.net/stickershop/v1/sticker/${sticker.stickerId}/android/sticker.png`"
                      alt="sticker"
                      class="w-full"
                    />
                  </div>
                </div>
                <button
                  class="mt-4 text-sm text-red-500 underline"
                  @click="showStickerPicker = false"
                >
                  ❌ ปิด
                </button>
              </div>
            </div>

            <!-- 🧭 Location Picker Modal -->
          <div v-if="showMapModal" class="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
            <div class="bg-white w-[90%] max-w-xl h-[70vh] rounded-lg overflow-hidden shadow-lg">
              <div class="flex justify-between items-center px-4 py-2 bg-green-600 text-white text-sm font-bold">
                <span>🧭 ปักหมุดตำแหน่ง</span>
                <button @click="showMapModal = false">✖️</button>
              </div>
              <div id="map" class="w-full h-full"></div>
            </div>
          </div>

        <!-- 📍 Location Option Modal -->
        <div
          v-if="showLocationOptionModal"
          class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
        >
          <div class="bg-white p-6 rounded-2xl shadow-xl w-[320px] text-center space-y-4 border border-gray-100">
            <h3 class="text-xl font-semibold text-gray-800">📍 ต้องการส่งแบบใด?</h3>

            <!-- ปุ่มแต่ละตัว ใช้โทนสีเดียวกัน (neutral + accent) -->
            <button
              @click="sendAllLocations"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              📋 ส่งสาขาทั้งหมด
            </button>

            <button
              @click="openPinMap"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              📍 ปักหมุดตำแหน่ง
            </button>

            <button
              @click="selectBranchManually"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              🔎 เลือกสาขาเอง
            </button>

            <button
              @click="openAddressSearchModal"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              🧭 ค้นหาจากที่อยู่
            </button>

            <button
              @click="showLocationOptionModal = false"
              class="text-sm text-gray-500 hover:underline mt-2"
            >
              ❌ ยกเลิก
            </button>
          </div>
        </div>

        <!-- 🎁 โปรโมชัน Modal -->
        <div
          v-if="showPromoModal"
          class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
        >
          <div class="bg-white p-6 rounded-2xl shadow-xl w-[320px] text-center space-y-4 border border-gray-100">
            <h3 class="text-xl font-semibold text-gray-800">🎁 โปรโมชัน</h3>

            <button
              @click="sendAllPromos"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              📋 ส่งโปรโมชั่นทั้งหมด
            </button>

            <button
              @click="selectPromoManually"
              class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg w-full text-sm font-medium transition"
            >
              🔍 เลือกโปรโมชั่นส่ง
            </button>

            <button
              @click="showPromoModal = false"
              class="bg-blue-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-blue-600"
            >
              ❌ ปิด
            </button>
          </div>          
        </div>

          <!-- 📍 เลือกสาขาเอง -->
          <div
            v-if="showBranchListModal"
            class="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center"
          >
            <div class="bg-white w-[90%] max-w-lg rounded-xl shadow-lg p-4 space-y-4 max-h-[80vh] overflow-y-auto">
              <div class="flex justify-between items-center">
                <h3 class="text-lg font-bold text-gray-800">🔎 เลือกสาขา</h3>
                <button @click="showBranchListModal = false" class="text-red-500">✖️</button>
              </div>

              <div
                v-for="branch in branches"
                :key="branch.location_id"
                class="border p-3 rounded-xl shadow-sm flex justify-between items-start"
              >
                <div class="flex-1">
                  <div class="font-bold">{{ branch.location_name }}</div>
                  <div class="text-xs text-gray-600">{{ branch.address }}</div>
                </div>
                <button
                  @click="sendSingleBranch(branch.location_id)"
                  class="bg-blue-500 text-white px-3 py-1 rounded text-sm"
                >
                  ➤ ส่ง
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="showAddressSearchModal"
            class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
          >
            <div class="bg-white p-6 rounded-2xl shadow-xl w-[320px] space-y-4 border border-gray-200 text-center">
              <h3 class="text-lg font-bold">🔎 ค้นหาที่อยู่</h3>

              <input
                v-model="addressQuery"
                type="text"
                placeholder="กรอกที่อยู่หรือรหัสไปรษณีย์"
                class="w-full border px-3 py-2 rounded text-sm"
              />

              <button
                @click="searchNearestBranchByAddress"
                class="bg-purple-500 text-white px-4 py-2 rounded-full w-full"
              >
                🔍 ค้นหา
              </button>

              <button
                @click="showAddressSearchModal = false"
                class="text-sm text-red-500 hover:underline"
              >
                ❌ ยกเลิก
              </button>
            </div>
          </div>



  </div>
</template>


<script>
/* global L */
/* global google */


import axios from "axios";

export default {
  name: "ChatPanel",
  props: {
    user: Object,
  },
  data() {
    return {
      messages: [],
      newMessage: "",
      showMapModal: false,
      selectedLatLng: null,
      pollingInterval: null,
      showMenu: false,
      showStickerPicker: false,
      showLocationOptionModal: false,
      showPromoModal: false, 
      showBranchListModal: false,
      googleApiKey: 'AIzaSyBSob2plh0dZsKtXys2U_gXKYcuac3suvE',
      addressQuery: "",
      branches: [],
      stickers: [
        { packageId: "1", stickerId: "1" },
        { packageId: "1", stickerId: "2" },
        { packageId: "1", stickerId: "3" },
        { packageId: "1", stickerId: "100" },
        { packageId: "1", stickerId: "110" },
        { packageId: "1", stickerId: "138" },
      ],
    };
  },
  mounted() {
    if (typeof L === 'undefined') {
      const leaflet = document.createElement("script");
      leaflet.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
      leaflet.onload = () => console.log("📌 Leaflet loaded");
      document.head.appendChild(leaflet);

      const leafletCss = document.createElement("link");
      leafletCss.rel = "stylesheet";
      leafletCss.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
      document.head.appendChild(leafletCss);
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser?.user_id) {
          this.fetchMessages(newUser.user_id);
          this.startPolling();
        }
      },
    },
  },
  beforeUnmount() {
    clearInterval(this.pollingInterval);
  },
  methods: {
    async fetchBranches() {
      try {
        const res = await axios.get("/api/location");
        this.branches = res.data;
      } catch (err) {
        console.error("❌ โหลดสาขาล้มเหลว:", err);
      }
    },
    async fetchMessages(userId) {
      try {
        const res = await axios.get(`/api/ctrans/${userId}`);
        const newMessages = res.data.map((m) => ({
          ...m,
          raw_json: typeof m.raw_json === "string" ? JSON.parse(m.raw_json) : m.raw_json,
        }))
        

        if (
          this.messages.length === 0 ||
          newMessages[newMessages.length - 1]?.ctrans_id !==
            this.messages[this.messages.length - 1]?.ctrans_id
        ) {
          this.messages = newMessages;
          this.scrollToBottom();
        }
      } catch (err) {
        console.error("❌ โหลดแชทล้มเหลว:", err);
      }
    },
    async sendSingleBranch(locationId) {
      try {
        await axios.post("/api/admin/send-location", {
          userId: this.user.user_id,
          branchId: locationId
        });
        this.showBranchListModal = false;
        this.fetchMessages(this.user.user_id);
      } catch (err) {
        console.error("❌ ส่งสาขาเดียวล้มเหลว:", err.response?.data || err.message || err);
        alert(`❌ ไม่สามารถส่งสาขานี้ได้: ${err.response?.data?.error || "Unknown Error"}`);
      }
    },
    startPolling() {
      clearInterval(this.pollingInterval);
      this.pollingInterval = setInterval(() => {
        if (this.user?.user_id) {
          this.fetchMessages(this.user.user_id);
        }
      }, 3000);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatEnd;
        if (el) el.scrollIntoView({ behavior: "auto" });
      });
    },
    formatDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleString("th-TH", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
    
    getQuickReplies(json) {
      try {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        return obj?.quickReply?.items || [];
      } catch {
        return [];
      }
    },
    extractTextFromRawJson(json) {
      try {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if (obj?.type === "text" && obj?.text) return obj.text;
        if (obj?._displayText) return obj._displayText;
        if (obj?.altText) return obj.altText;
        return (
          obj?.contents?.contents?.[0]?.body?.contents?.[0]?.contents?.[0]?.text ||
          obj?.contents?.body?.contents?.[0]?.text ||
          ""
        );
      } catch {
        return "";
      }
    },
    getTimeRows(card) {
      const rows = [];

      try {
        // ลอง path ที่อาจเป็นเวลาเปิด-ปิด
        const paths = [
          card?.body?.contents?.[2]?.contents?.[0]?.contents, // loc_ans_show_all
          card?.body?.contents?.[1]?.contents?.[0]?.contents, // loc_ans_gps_show, loc_ans_show_address
        ];

        for (const path of paths) {
          if (Array.isArray(path)) {
            for (const box of path) {
              const c = box.contents;
              if (Array.isArray(c) && c.length >= 2 && c[0].text && c[1].text) {
                const day = c[0].text;
                const time = c[1].text;
                if (day !== "วัน" && time !== "เวลา") {
                  rows.push({ day, time });
                }
              }
            }
            if (rows.length > 0) break; // เจอชุดที่ใช้ได้ก็พอแล้ว
          }
        }
      } catch (e) {
        console.warn("⚠️ อ่านเวลาเปิด-ปิดไม่สำเร็จ:", e);
      }

      return rows;
    },
    getAdminEmoji(rawJson) {
      try {
        const firstItem = rawJson?.contents?.header?.contents?.[0];
        return firstItem?.type === "text" ? firstItem.text : "🧑‍💻";
      } catch {
        return "🧑‍💻";
      }
    },
    getMapUrl(card) {
      return (
        card?.body?.contents?.[2]?.contents?.[1]?.contents?.[0]?.action?.uri ||
        card?.body?.contents?.[1]?.contents?.[1]?.contents?.[0]?.action?.uri ||
        "#"
      );
    },
    getCallUrl(card) {
      return (
        card?.body?.contents?.[2]?.contents?.[1]?.contents?.[1]?.action?.uri ||
        card?.body?.contents?.[1]?.contents?.[1]?.contents?.[1]?.action?.uri ||
        "#"
      );
    },
    getBotMapUrl(card) {
      try {
        // 💡 เข้า path ให้ตรงกับ JSON ของคุณ
        const mapBtn = card?.body?.contents?.[2]?.contents?.[1]?.contents?.[0];
        if (mapBtn?.action?.uri?.includes("maps") || mapBtn?.action?.uri?.includes("redirect")) {
          return mapBtn.action.uri;
        }

        // ⛑ fallback แบบวนหา
        const json = JSON.stringify(card);
        const match = json.match(/https?:\/\/[^"]*maps[^"]*/);
        if (match) return match[0];

        return "#";
      } catch (e) {
        console.warn("⚠️ getBotMapUrl fallback:", e);
        return "#";
      }
    },
    getBotCallUrl(card) {
      const btns = card?.body?.contents?.[2]?.contents?.[1]?.contents;
      if (Array.isArray(btns)) {
        const callBtn = btns.find(btn => btn?.action?.uri?.startsWith("https://") && btn.action.uri.includes("tel:"));
        if (callBtn) return callBtn.action.uri;
      }
      return "#";
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    selectAction(action) {
      this.showMenu = false;

      switch (action) {
        case "location":
          this.showLocationOptionModal = true; 
          break;

        case "promo":
          this.showPromoModal = true; 
          break;

        case "sticker":
          this.showStickerPicker = true;
          break;

        case "images":
          this.$refs.imageInput.click();
          break;

        default:
          alert("🚧 ฟีเจอร์กำลังมาเร็ว ๆ นี้");
      }
    },
    getStickerUrl(json) {
        try {
          const obj = typeof json === "string" ? JSON.parse(json) : json;
          const stickerId =
            obj?.message?.stickerId || // ✅ กรณี LINE ส่ง sticker
            obj?.stickerId ||          // ✅ กรณีที่บันทึกแบบแบนราบไว้
            null;

          if (!stickerId) throw new Error("No stickerId found");
          return `https://stickershop.line-scdn.net/stickershop/v1/sticker/${stickerId}/android/sticker.png`;
        } catch (err) {
          console.warn("⚠️ ไม่สามารถสร้าง URL สติกเกอร์ได้:", err);
          return "https://placehold.co/100x100?text=No+Sticker";
        }
    },
    async sendStickerById(packageId, stickerId) {
      try {
        await axios.post("/api/send-message", {
          userId: this.user.user_id,
          messageType: "sticker",
          packageId,
          stickerId,
        });
        this.showStickerPicker = false;
        this.fetchMessages(this.user.user_id);
      } catch (err) {
        console.error("❌ ส่งสติกเกอร์ล้มเหลว:", err);
      }
    },
    async sendMessage() {
      if (!this.newMessage.trim()) return;
      const message = this.newMessage;
      this.newMessage = "";

      try {
        await axios.post("/api/send-message", {
          userId: this.user.user_id,
          message,
        });
        this.fetchMessages(this.user.user_id);
      } catch (err) {
        console.error("❌ ส่งข้อความล้มเหลว:", err);
      }
    },
    async handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("image", file);
      formData.append("userId", this.user.user_id);

      try {
        await axios.post("/api/upload-image", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        this.fetchMessages(this.user.user_id);
      } catch (err) {
        console.error("❌ ส่งรูปภาพล้มเหลว:", err);
      }
    },
    async sendPinnedLocation(lat, lng) {
      try {
        await axios.post("/api/admin/send-pinned-location", {
          userId: this.user.user_id,
          latitude: lat,
          longitude: lng,
        });

        this.fetchMessages(this.user.user_id);
      } catch (err) {
        console.error("❌ ปักหมุดล้มเหลว:", err);
        alert("❌ ไม่สามารถส่งพิกัดได้");
      }
    },
    sendAllLocations() {
      this.showLocationOptionModal = false;
      axios.post("/api/admin/send-all-locations", {
        userId: this.user.user_id,
      })
      .then(() => this.fetchMessages(this.user.user_id))
      .catch((err) => {
        console.error("❌ ส่งสาขาทั้งหมดล้มเหลว:", err);
        alert("❌ ไม่สามารถส่งข้อมูลสาขาได้");
      });
    },
    openPinMap() {
        this.showLocationOptionModal = false;
        this.showMapModal = true;

        this.$nextTick(() => {
          // โหลด Google Maps
          if (!window.google) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleApiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = this.initGoogleMap;
            document.head.appendChild(script);
          } else {
            this.initGoogleMap();
          }
        });
    },
    initGoogleMap() {
      const center = { lat: 13.7563, lng: 100.5018 }; // กรุงเทพ
      const map = new google.maps.Map(document.getElementById('map'), {
        center,
        zoom: 10,
      });

      let marker = null;

      map.addListener('click', (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        this.selectedLatLng = { lat, lng };

        if (marker) {
          marker.setPosition(e.latLng);
        } else {
          marker = new google.maps.Marker({
            position: e.latLng,
            map: map,
          });
        }

        if (confirm(`📍 ยืนยันตำแหน่ง (${lat.toFixed(6)}, ${lng.toFixed(6)}) ?`)) {
          this.sendPinnedLocation(lat, lng);
          this.showMapModal = false;
        }
      });
    },
    selectBranchManually() {
      this.showLocationOptionModal = false;
      this.showBranchListModal = true;
      this.fetchBranches();
    },
    openAddressSearchModal() {
      this.showLocationOptionModal = false;
      this.showAddressSearchModal = true;
    },
    async searchNearestBranchByAddress() {
    try {
        await axios.post("/api/admin/search-location", {
        userId: this.user.user_id,
        address: this.addressQuery
      });

      this.showAddressSearchModal = false;
      this.fetchMessages(this.user.user_id);
    } catch (err) {
      console.error("❌ ค้นหาที่อยู่ล้มเหลว:", err);
      alert("❌ ไม่สามารถค้นหาสาขาได้จากที่อยู่นี้");
    }
    },
    closeModal() {
      this.showAddressSearchModal = false;
      this.addressQuery = "";
    },
    getStaticMapUrl(msg) {
      if (msg.raw_json?.message?.static_map_image) {
        return `https://f5ca-49-228-106-44.ngrok-free.app${msg.raw_json.message.static_map_image}`;
      }
      if (msg.raw_json?.contents?.hero?.url) {
        return msg.raw_json.contents.hero.url;
      }
      return "https://placehold.co/600x400?text=No+Map";
    },
    sendAllPromos() {
      axios.post("/api/admin/send-all-promos", {
        userId: this.user.user_id,
     })
      .then(() => {
        this.fetchMessages(this.user.user_id);
        this.showPromoModal = false;
      })
      .catch((err) => {
        console.error("❌ ส่งโปรโมชันล้มเหลว:", err);
        alert("❌ ไม่สามารถส่งข้อมูลโปรโมชันได้");
      });
    },

    groupDays(openDays) {
      if (!openDays) return [];

      const dayOrder = ["จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์", "อาทิตย์"];
      const filledDays = {};

      // ใส่ null ให้ครบ 7 วัน
      for (const day of dayOrder) {
        filledDays[day] = openDays[day] || null;
      }

      const result = [];
      let currentGroup = [];
      let currentTime = null;

      for (const day of dayOrder) {
        const time = filledDays[day];

        if (time && time === currentTime) {
          currentGroup.push(day);
        } else {
          if (currentGroup.length > 0) {
            result.push({ days: this.formatDayRange(currentGroup), time: currentTime });
          }
          currentGroup = time ? [day] : [];
          currentTime = time;
        }
      }

      if (currentGroup.length > 0) {
        result.push({ days: this.formatDayRange(currentGroup), time: currentTime });
      }

      return result.filter(r => r.time);
    },

    formatDayRange(days) {
      return days.length === 1 ? days[0] : `${days[0]}-${days[days.length - 1]}`;
    },
    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    },
    async requestNewSlip(orderId, userId) {
      console.log('ร้องขอสลิปใหม่สำหรับ Order ID:', orderId, 'UserID:', userId);
      try {
        const response = await fetch(`/api/orders/${orderId}/reject-slip`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: userId }),
        });

        if (response.ok) {
          console.log('ร้องขอสลิปใหม่สำเร็จ');
          // TODO: อัปเดต UI หรือแจ้งเตือนผู้ใช้
        } else {
          console.error('เกิดข้อผิดพลาดในการร้องขอสลิปใหม่');
          const errorData = await response.json();
          console.error(errorData);
          // TODO: แสดงข้อผิดพลาดให้ผู้ใช้เห็น
        }
      } catch (error) {
        console.error('เกิดข้อผิดพลาดในการเรียก API:', error);
        // TODO: แสดงข้อผิดพลาดให้ผู้ใช้เห็น
      }
    },

    async approveSlip(orderId, userId) {
      console.log('อนุมัติสลิปสำหรับ Order ID:', orderId, 'UserID:', userId);
      try {
        const response = await fetch(`/api/orders/${orderId}/approve-slip`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: userId }),
        });

        if (response.ok) {
          console.log('อนุมัติสลิปสำเร็จ');
          // TODO: อัปเดต UI หรือแจ้งเตือนผู้ใช้
        } else {
          console.error('เกิดข้อผิดพลาดในการอนุมัติสลิป');
          const errorData = await response.json();
          console.error(errorData);
          // TODO: แสดงข้อผิดพลาดให้ผู้ใช้เห็น
        }
      } catch (error) {
        console.error('เกิดข้อผิดพลาดในการเรียก API:', error);
        // TODO: แสดงข้อผิดพลาดให้ผู้ใช้เห็น
      }
    }

  },
};
</script>